import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services/updateData';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
export const EditUserForm = ({ user, setUsers, onClose }) => {
    const [formData, setFormData] = useState({
        is_admin: user?.is_admin || false,
        job_title: user?.job_title || '',
        user_type: user?.user_type || 'standard'
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const { token, base_url } = useAppContext();

    const userTypes = [
        'Standard',
        'Design Only'
    ];

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isLoading) return; // Prevent multiple submissions
        
        setIsLoading(true);
        setError('');

        try {
            console.log('Updating user with data:', formData);
            const response = await updateData(token, `${base_url}/apis/admin/users/${user.id}`, formData);

            if (response && response.user) {
                setUsers(prevUsers => prevUsers.map(u => u.id === user.id ? response.user : u));
                window.showAlert(200, 'User updated successfully!');
                console.log('User updated successfully!');
                onClose();
            } else {
                window.showAlert(500, 'Failed to update user: ' + response?.msg);
                console.log('Failed to update user');
            }
        } catch (err) {
            setError('Failed to update user. Please try again.');
            console.error('Update user error:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button 
                    className="modal-close-button"
                    onClick={onClose}
                >
                    ×
                </button>
                
                <h2 className="modal-title">Edit User: {user.first_name} {user.last_name}</h2>
                
                {error && (
                    <div className="form-error-banner">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label">
                            <input
                                type="checkbox"
                                name="is_admin"
                                checked={formData.is_admin}
                                onChange={handleInputChange}
                                className="form-check-input"
                            />
                            Admin User
                        </label>
                        <p className="form-helper-text">
                            Check this box to give this user admin privileges
                        </p>
                    </div>

                    <div className="form-group">
                        <label htmlFor="job_title" className="form-label">
                            Job Title
                        </label>
                        <input
                            type="text"
                            id="job_title"
                            name="job_title"
                            className="form-input"
                            value={formData.job_title}
                            onChange={handleInputChange}
                            placeholder="e.g., Project Manager"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="user_type" className="form-label">
                            User Type
                        </label>
                        <select
                            id="user_type"
                            name="user_type"
                            className="form-select"
                            value={formData.user_type}
                            onChange={handleInputChange}
                        >
                            {userTypes.map((type) => (
                                <option key={type} value={type}>
                                    {type.charAt(0).toUpperCase() + type.slice(1)}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-actions">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <FontAwesomeIcon icon={faSpinner} spin /> Updating...
                                </>
                            ) : (
                                'Update User'
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
